import type { ReactNode } from "react";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from "@/shared/components/ui/context-menu";

export function BossHeaderContextMenu({
  skipped,
  canCopyPrevious,
  onSelectAll,
  onSelectNone,
  onCopyPrevious,
  onToggleSkip,
  children,
}: {
  skipped: boolean;
  canCopyPrevious: boolean;
  onSelectAll: () => void;
  onSelectNone: () => void;
  onCopyPrevious: () => void;
  onToggleSkip: () => void;
  children: ReactNode;
}) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        {/* A skipped boss is inert — its assignment shortcuts stay visible but disabled. */}
        <ContextMenuItem disabled={skipped} onSelect={onSelectAll}>
          Alla spelare
        </ContextMenuItem>
        <ContextMenuItem disabled={skipped} onSelect={onSelectNone}>
          Inga spelare
        </ContextMenuItem>
        {canCopyPrevious && (
          <ContextMenuItem disabled={skipped} onSelect={onCopyPrevious}>
            Kopiera föregående boss
          </ContextMenuItem>
        )}
        <ContextMenuSeparator />
        <ContextMenuItem onSelect={onToggleSkip}>
          {skipped ? "Ta tillbaka boss" : "Hoppa över boss"}
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
